<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="category" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('category')">
                            <ParameterSelectbox code="housing_misconduct_categories" v-model="formData.category"
                                                :validate-error="errors[0]"
                                                ></ParameterSelectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="explanation" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('explanation')">
                            <b-form-textarea v-model="formData.explanation"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="5"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="consequence" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('consequence')">
                            <ParameterSelectbox code="housing_misconduct_consequences"  :multiple="true" v-model="formData.consequence"
                                                :validate-error="errors[0]"
                            ></ParameterSelectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="consequence_explanation" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('consequence_explanation')">
                            <b-form-textarea v-model="formData.consequence_explanation"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="5"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="consequence_amount" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('consequence_amount')">
                            <b-form-input type="number" v-model="formData.consequence_amount"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="5"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>


            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="storeForm">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
import {ValidationProvider, ValidationObserver} from "vee-validate"
import moment from "moment";
import HousingMisconductsServices from "@/services/HousingMisconductsServices";
export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props:{
        reservationId:{
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                category:null,
                explanation:null,
                consequence:null,
                consequence_explanation:null,
                consequence_amount:null
            },
        }
    },
    methods: {
        async storeForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.formData.housing_reservation_id=this.reservationId;
                HousingMisconductsServices.store(this.formData)
                    .then(response => {
                        this.$emit('createFormSuccess', true);
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate);
                    })
                    .finally(() => {
                        this.formLoading = false
                    })
            }
        }
    }
}
</script>
